import { render, staticRenderFns } from "./PaymentTableModal.vue?vue&type=template&id=196cf016&"
import script from "./PaymentTableModal.vue?vue&type=script&lang=js&"
export * from "./PaymentTableModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports